import Phaser from 'phaser';
import WorkArea from '../WorkArea';
import WhippedSprayDisplay from './WhippedSprayDisplay';
import ABCyaPhaser from '@abcya/abcya_phaser';
import UIAssetKeys from '../../UIAssetKeys';
import SoundAssetKeys from '../../SoundAssetKeys';

export default class WhippedCreamView extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {WorkArea} delegate
   */
  constructor(scene, delegate, workAreaPositions) {
    super(scene);

    this.delegate = delegate;
    this.viewPositions = workAreaPositions;

    this.isSquirting = false;
    this.canLand = false;
    this.spraySound = null;
    this.currentWhipNum = 1;
    this.baseDabHeight = -130;
    this.dabHeight = -130;

    this.dabRect = { x: 200, y: 200, width: 500, height: 200 };

    this.sprayDisplay = new WhippedSprayDisplay(this.scene, this.viewPositions);
    this.add(this.sprayDisplay);

    this.bottle = ABCyaPhaser.Images.addImage(this.viewPositions.centerX,0,UIAssetKeys._Whipping_Bottle, this).setInteractive({ draggable: true });
    this.bottle.destY = 10;
    this.bottle.sprayY = 50;
    this.bottle.maxY = 60;
    this.bottle.y = this.bottle.destY - this.bottle.height;
    this.bottle.startY = this.bottle.y;
    this.bottle.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.grabBottle, this);
    this.bottle.on(Phaser.Input.Events.GAMEOBJECT_DRAG, this.dragBottle, this);
    this.bottle.on(Phaser.Input.Events.GAMEOBJECT_DRAG_END, this.dropBottle, this);
  }

  grabBottle (pointer) {
    this.scene.tweens.killTweensOf(this.bottle);

    this.bottle.dragOffsetX = this.bottle.x - pointer.x;
    this.bottle.dragOffsetY = this.bottle.y - pointer.y;
  }

  dragBottle (pointer) {
    const newX = pointer.x + this.bottle.dragOffsetX;
    this.bottle.x = newX;
    const bxo = this.bottle.width;
    if (this.bottle.x - bxo <= this.viewPositions.left) this.bottle.x = this.viewPositions.left + bxo;
    if (this.bottle.x + bxo >= this.viewPositions.right) this.bottle.x = this.viewPositions.right - bxo;

    const newY = pointer.y + this.bottle.dragOffsetY;

    const dist = this.viewPositions.centerX - this.bottle.x;
    const maxdist = this.viewPositions.centerX - this.viewPositions.right - bxo;
    const en = dist / maxdist;
    let yoff = en * 213;
    yoff = Math.abs(yoff);
    this.dabHeight = this.baseDabHeight + yoff * 1.1;
    if (newY < this.bottle.maxY && newY > this.bottle.destY) {
      this.bottle.y = newY;
      this.dabRect.y = this.sundaeTopY + this.dabHeight;
      if (newY >= this.bottle.sprayY) {
        if (!this.isSquirting) {
          this.initSquirt(newX);
        }
        else {
          this.dabRect.x = this.bottle.x;
          this.dabRect.y = this.sundaeTopY + this.dabHeight;
          const diff = this.sprayStartX - newX;
          if (diff > 46 || diff < -46) {
            this.sprayStartX = newX;
            this.dabRect.width = 2;
            this.dabRect.height = 2;
            this.sprayDisplay.setHitArea(this.dabRect);
            this.sprayDisplay.moveHitArea(this.dabRect.x, this.dabRect.y);
          }
          else if (diff >= 12 || diff <= -12) {
            this.sprayDisplay.adjustHitAreaForMove(this.dabRect.x, this.dabRect.y);
          }
        }
      }
    }
    else if (this.isSquirting) {
      const diff = this.sprayStartX - newX;
      if (diff > 46 || diff < -46) {
        this.sprayStartX = newX;
        this.dabRect.x = this.bottle.x;
        this.dabRect.y = this.sundaeTopY + this.dabHeight;
        this.dabRect.width = 2;
        this.dabRect.height = 2;
        this.sprayDisplay.moveHitArea(this.dabRect.x, this.dabRect.y);
      }
      else if (diff >= 6 || diff <= -6) {
        this.sprayDisplay.adjustHitAreaForMove(this.dabRect.x, this.dabRect.y);
      }
    }
    else {
      if (this.spraySound) {
        this.spraySound.stop();
        this.spraySound.destroy();
        this.spraySound = null;
      }
    }
    if (newY > this.bottle.maxY) {
      this.bottle.y = this.bottle.maxY;
      if (!this.isSquirting) {
        this.initSquirt(newX);
      }
    }
  }

  initSquirt (newX) {
    this.spraySound = ABCyaPhaser.Audio.createSound(this.scene);
    ABCyaPhaser.Audio.playSound(SoundAssetKeys._SPRAY_CAN_Spray_Loop_02_loop_mono, this.spraySound, 1, true);

    this.sprayStartX = newX;
    this.isSquirting = true;
    this.dabRect.x = this.bottle.x + 4;
    this.dabRect.y = this.sundaeTopY + this.dabHeight;
    this.dabRect.width = 2;
    this.dabRect.height = 2;
    this.sprayDisplay.setHitArea(this.dabRect);
    this.sprayDisplay.startSquirt(this.currentWhipNum);
  }

  dropBottle () {
    if (this.spraySound) {
      this.spraySound.stop();
      this.spraySound.destroy();
      this.spraySound = null;
    }
    this.bottle.angle = 0;
    this.isSquirting = false;
    this.scene.tweens.killTweensOf(this.bottle);
    ABCyaPhaser.Tweens.addTween(this.bottle, 400, { y: this.bottle.destY,easeParams: [1, 0.3] }, Phaser.Math.Easing.Elastic.Out);
  }

  doOutro (time = 1200) {
    const prevCream = this.sprayDisplay.getWhipImage(this.topOffset);
    if (prevCream !== null) {
      this.delegate.addWhippedCreamDab(prevCream);
    }
    this.isActive = false;

    this.scene.tweens.killTweensOf(this.bottle);
    ABCyaPhaser.Tweens.addTween(this.bottle, time, { y: this.bottle.startY, easeParams: [1,2] }, Phaser.Math.Easing.Elastic.Out);
  }

  updateWhippedCream() {
    const prevCream = this.sprayDisplay.getWhipImage(this.topOffset);
    if (prevCream !== null) {
      this.delegate.addWhippedCreamDab(prevCream);
    }
  }

  bringCream (sundaeTop, topOffset) {
    this.sundaeTopY = sundaeTop;
    this.topOffset = topOffset;
    this.bottle.x = this.viewPositions.centerX;

    this.isActive = true;
    const time = 1000;
    this.scene.tweens.killTweensOf(this.bottle);
    ABCyaPhaser.Tweens.addTween(this.bottle, time, { y: this.bottle.destY, easeParams: [1, 0.75] }, Phaser.Math.Easing.Elastic.Out);
  }

  switchCream (creamNum) {
    this.currentWhipNum = creamNum;
  }

  update (dt) {
    this.sprayDisplay.update(dt);

    if (this.isSquirting === true) {
      this.sprayDisplay.doSpray(this.bottle.x, this.bottle.y + this.bottle.height / 2 - 20);
    }
  }
}